var axios = require('axios')
const prefixCustomer = process.env.prefix_customer_be
const prefixCoupon = process.env.prefix_coupon
const gamificationUrl = `/${process.env.version_v4}/${process.env.prefix_gamification}`
const prefixCustomerV4 = `/${process.env.version_v4}/${process.env.prefix_customer_be}`

const encodeParams = (params) =>
  params
    .split('&')
    .map(pair => {
    const [key, value] = pair.split('=')
    return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
    })
    .join('&')

// get list users
axios.getCustomers = function (params, success, callBackError, attributes = {}) {
  let url = prefixCustomer + '/customers?' + params
  if (attributes.useApiV4) {
    url = process.env.host + prefixCustomerV4 + '/customers?' + encodeParams(params)
  }
  this.get(url)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getCustomersPromise = async (params, attributes = {}) => {
  let url = prefixCustomer + '/customers?' + params
  if (attributes.useApiV4) {
    url = process.env.host + prefixCustomerV4 + '/customers?' + encodeParams(params)
  }
  const response = await axios.get(url)
  return response
}
/**
 * update status of customise session
 */
axios.getCustomerDetail = function (params, success, callBackError, attributes) {
  let urlV1 = prefixCustomer + '/customers/' + params.id
  let urlV4 = process.env.host + prefixCustomerV4 + '/customers/' + params.id
  
  if (attributes.useApiV4) {
    // Call V4 first
    this.get(urlV4)
      .then(response => {
        if (response.status === 200) {
          success(response)
        } else {

          // Fallback to V4 if failure
          this.get(urlV1).then(response => {
            success(response)
          }).catch(error => {
            // Eventually fail if V4 fails
            if (typeof callBackError !== 'undefined') {
              callBackError(error.response.data)
            }
          })

        }
      }).catch(error => {

        // Fallback to V4 if failure
        this.get(urlV1).then(response => {
          success(response)
        }).catch(error => {
          // Eventually fail if V4 fails
          if (typeof callBackError !== 'undefined') {
            callBackError(error.response.data)
          }
        })

      })
  } else {
    this.get(urlV1)
      .then(response => {
        success(response)
      }).catch(error => {
        if (error.response && error.response.status == 400) {
          if (typeof callBackError !== 'undefined') {
            callBackError(error.response.data)
          }
        }
      })
  }
}

axios.getCouponDetailForUser = function (params, success, callBackError) {
  this.get(prefixCoupon + '/coupons-user' + params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.updateCustomerProfile = function (params, success, callBackError) {
  this.put(prefixCustomer + '/customers/' + params.id, params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}
axios.getMemberShip = function (success, callBackError) {
  this.get(prefixCustomer + '/memberships')
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}
axios.getMemberShipOfCustomer = function (params,success, callBackError) {
  this.get(prefixCustomer + '/memberships/' + params.id)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.saveMemberShipOfCustomer = function (params,success, callBackError) {
  this.put(prefixCustomer + '/memberships/' + params.id,params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.updateAddressCustomerProfile = function (params,success, callBackError) {
  this.put(prefixCustomer + '/locations/' + params.id, params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
  })
}

axios.disableCustomer = function (params,success, callBackError) {
  this.put(prefixCustomer + '/customers/' + params.id,params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}
axios.deleteCustomer = function (params,success, callBackError) {
  this.delete(prefixCustomer + '/customers/' + params.id)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getGamificationTicketsHistory = function (params,success, callBackError) {
  this.get(process.env.host + gamificationUrl + '/history?scope=tickets&customer_id=' + (params.cid || 0) + '&page=' + params.page + '&limit=' + params.limit)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

export default axios



// WEBPACK FOOTER //
// ./src/assets/api/Customer.js